import React, { useState } from 'react';
import {
  List,
  TextField,
  Filter,
  SearchInput,
  DateField,
  ReferenceField,
  FunctionField,
  EmailField,
  useListContext,
  BulkDeleteWithConfirmButton,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { List as MUIList, Paper } from '@material-ui/core';

import { ZippityDatagrid } from '../../components';

import QuoteRequestInfo from './QuoteRequestInfo';
import QuoteRequestOverview from './QuoteRequestOverview';
import FlagToggle from './components/FlagToggle';

const useStyles = makeStyles(() => ({
  list: {
    padding: '0',
    margin: '0em 0em 0em 0.75em',
  },
  aside: {
    width: '30%',
  },
}));

const QuoteRequestListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

const QuoteBulkActions = (props) => <BulkDeleteWithConfirmButton {...props} />;

const Aside = ({ currentId, quoteData, onClickAway }) => {
  // Need this next line to figure out how to put in default data
  const classes = useStyles();
  const { data } = useListContext();
  const totalRequestsCount = Object.keys(data).length;
  return (
    <div className={classes.aside}>
      <MUIList className={classes.list}>
        {quoteData?.length > 0 ? (
          <QuoteRequestInfo
            quoteRequestData={data[currentId]}
            quoteAnswers={quoteData}
            onClickAway={onClickAway}
            includeBuildLink
          />
        ) : (
          <Paper>
            <QuoteRequestOverview totalRequestsCount={totalRequestsCount} />
          </Paper>
        )}
      </MUIList>
    </div>
  );
};

const QuoteRequestList = (props) => {
  const [
    selectedQuoteRequestAnswers,
    setSelectedQuoteRequestAnswers,
  ] = useState([]);
  const [currentSelectedId, setCurrentSelectedId] = useState(null);
  const postRowClickAway = () => {
    setSelectedQuoteRequestAnswers([]);
    setCurrentSelectedId(null);
  };

  const postRowClick = (id, basePath, record) => {
    setSelectedQuoteRequestAnswers(record.answers);
    setCurrentSelectedId(id);
  };
  const postRowStyle = (record) => ({
    backgroundColor:
      record.id === currentSelectedId ? 'rgba(0, 0, 0, 0.04)' : null,
  });

  return (
    <List
      {...props}
      title="Quote Request Manager"
      bulkActionButtons={<QuoteBulkActions />}
      filters={<QuoteRequestListFilter />}
      filterDefaultValues={{ is_deleted: false }}
      filter={{ no_quotes: true }}
      sort={{ field: 'created_at', order: 'ASC' }}
      perPage={50}
      exporter={false}
      aside={
        <Aside
          quoteData={selectedQuoteRequestAnswers}
          currentId={currentSelectedId}
          onClickAway={postRowClickAway}
        />
      }
    >
      <ZippityDatagrid rowClick={postRowClick} rowStyle={postRowStyle}>
        <TextField source="id" />
        <DateField source="created_at" label="Date Requested" />
        <EmailField source="customer_email" />
        <ReferenceField source="customer_id" reference="customer" link="show">
          <FunctionField
            render={(record) =>
              record ? `${record.first_name} ${record.last_name}` : null
            }
          />
        </ReferenceField>
        <ReferenceField source="vehicle_id" reference="vehicle" link={false}>
          <TextField source="display_name" />
        </ReferenceField>
        <FlagToggle {...props} />
      </ZippityDatagrid>
    </List>
  );
};

export default QuoteRequestList;
